module.exports = [
	{
		"id": "8f36d23c-5056-43df-9711-751903aaa43a",
		"albumId": "8f36d23c-5056-43df-9711-751903aaa43a",
		"slug": "farming-in-the-world",
		"caption": "Farming in the world",
		"alt": "Norwegian cottage",
		"username": "cabday",
		"width": 1920,
		"height": 1280,
		"imageUrl": "https://images01.foap.com/images/966e9af7-b64b-43bf-a0e6-312b858e49f5/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Farming in the world"
	},
	{
		"id": "c3124ef4-23e5-4320-a617-bbe296ce185d",
		"albumId": "c3124ef4-23e5-4320-a617-bbe296ce185d",
		"slug": "food-market",
		"caption": "Food market",
		"alt": "Halfs",
		"username": "cabday",
		"width": 1920,
		"height": 1280,
		"imageUrl": "https://images02.foap.com/images/2d684a32-7ee3-4a95-84e6-713a870ba63b/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Food market"
	},
	{
		"id": "21c631b3-e282-4168-ac78-42d52050bff3",
		"albumId": "21c631b3-e282-4168-ac78-42d52050bff3",
		"slug": "good-eats",
		"caption": "Good Eats",
		"alt": "Food for a diet: grilled fish. White plate with grilled mackerel, rocket salad and boiled rice over white background. Dish for dieting. Healthy food.",
		"username": "catherine.douma",
		"width": 2592,
		"height": 3888,
		"imageUrl": "https://images01.foap.com/images/a3e14318-adf8-4bcc-b925-a00e8a86860c/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Good Eats"
	},
	{
		"id": "4f04e6f3-bd14-4f4d-b0df-3613a78f7c07",
		"albumId": "4f04e6f3-bd14-4f4d-b0df-3613a78f7c07",
		"slug": "perfectly-arranged-breakfast-photos",
		"caption": "Perfectly arranged breakfast photos",
		"alt": null,
		"username": "akilles",
		"width": 4528,
		"height": 2548,
		"imageUrl": "https://images01.foap.com/images/10b8cc37-f5a3-4ed9-a885-46b865e1bdf5/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Perfectly arranged breakfast photos"
	},
	{
		"id": "5213f477-b1cc-436c-aa72-88f62c941e32",
		"albumId": "5213f477-b1cc-436c-aa72-88f62c941e32",
		"slug": "beautiful-lisbon-lisboa",
		"caption": "Beautiful Lisbon / Lisboa",
		"alt": "Christ the king statue in lisbon ",
		"username": "julieweiss10",
		"width": 3644,
		"height": 5460,
		"imageUrl": "https://images01.foap.com/images/ec9ae1fa54c94f5a80c5985b12c3a49d/original.jpg?filename=web_review&dw=640",
		"selectedCaption": "Beautiful Lisbon / Lisboa"
	},
	{
		"id": "13a7190c-a528-438d-abbc-66fc34f1efbe",
		"albumId": "13a7190c-a528-438d-abbc-66fc34f1efbe",
		"slug": "beautiful-scotland",
		"caption": "Beautiful Scotland ",
		"alt": "Highland Country fence ",
		"username": "julieweiss10",
		"width": 5464,
		"height": 3624,
		"imageUrl": "https://images01.foap.com/images/c69342ea-9236-45e3-b370-acc48c613b33/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Beautiful Scotland "
	},
	{
		"id": "be3020c4-ecb5-4d43-94b4-d45e4fae6994",
		"albumId": "be3020c4-ecb5-4d43-94b4-d45e4fae6994",
		"slug": "beautiful-prague-praha",
		"caption": "Beautiful Prague / Praha",
		"alt": "Metal dog statue",
		"username": "julieweiss10",
		"width": 3648,
		"height": 5472,
		"imageUrl": "https://images03.foap.com/images/a3ecc62ed7f64d3f9cbf970ea3fd718e/original.jpg?filename=web_review&dw=640",
		"selectedCaption": "Beautiful Prague / Praha"
	},
	{
		"id": "487a2581-b89d-4358-a7f4-554645c51302",
		"albumId": "487a2581-b89d-4358-a7f4-554645c51302",
		"slug": "summer-vacations",
		"caption": "Summer & Vacations",
		"alt": "Little girl",
		"username": "przemekklos",
		"width": 2048,
		"height": 2048,
		"imageUrl": "https://images01.foap.com/images/01d77fd32d954c01b72a27f03b569024/original.jpg?filename=web_review&dw=640",
		"selectedCaption": "Summer & Vacations"
	},
	{
		"id": "54ae83b1-d2e6-4c65-bcd9-01248504d08c",
		"albumId": "54ae83b1-d2e6-4c65-bcd9-01248504d08c",
		"slug": "nature",
		"caption": "Nature",
		"alt": "Lush greenery on a river",
		"username": "przemekklos",
		"width": 3264,
		"height": 2448,
		"imageUrl": "https://images03.foap.com/images/d550ce960b214a808c3299f970191a80/original.jpg?filename=web_review&dw=640",
		"selectedCaption": "Nature"
	},
	{
		"id": "e0573704-747d-4bc5-94aa-9636172ff496",
		"albumId": "e0573704-747d-4bc5-94aa-9636172ff496",
		"slug": "food-drinks",
		"caption": "Food & Drinks",
		"alt": "Dried tomatoes. Dried tomatoes on baking parchment paper",
		"username": "przemekklos",
		"width": 3648,
		"height": 5472,
		"imageUrl": "https://images03.foap.com/images/166ed1cf-d062-4a7d-b90d-e76bf499e1c4/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Food & Drinks"
	},
	{
		"id": "ce547271-53d9-4393-935a-b84c88bcfb98",
		"albumId": "ce547271-53d9-4393-935a-b84c88bcfb98",
		"slug": "christmas",
		"caption": "Christmas",
		"alt": "Girl decorating baked Christmas gingerbread cookies with frosting writing pen",
		"username": "przemekklos",
		"width": 3648,
		"height": 5472,
		"imageUrl": "https://images01.foap.com/images/616d06a6-46f5-4655-a40b-c75ead796142/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Christmas"
	},
	{
		"id": "159e6bc8-78e9-47dd-a13f-8a1c080ec5f4",
		"albumId": "159e6bc8-78e9-47dd-a13f-8a1c080ec5f4",
		"slug": "pacific-northwest",
		"caption": "Pacific Northwest",
		"alt": "Fog",
		"username": "mbocast",
		"width": 2304,
		"height": 1536,
		"imageUrl": "https://images01.foap.com/images/2c823131-18e2-4c00-835e-13886d2661b5/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Pacific Northwest"
	},
	{
		"id": "8fba80d3-7102-42bd-893a-fcac0e2104c2",
		"albumId": "8fba80d3-7102-42bd-893a-fcac0e2104c2",
		"slug": "underwater-world",
		"caption": "Underwater world",
		"alt": "cebu silhouette diving underwater by paulcowell",
		"username": "paulcowell",
		"width": 2304,
		"height": 1536,
		"imageUrl": "https://images01.foap.com/images/bdbd7a8e63da4a4299e776fc45be2489/original.jpg?filename=web_review&dw=640",
		"selectedCaption": "Underwater world"
	},
	{
		"id": "e7d91e55-ce91-4a24-8624-bb7626f8bd86",
		"albumId": "e7d91e55-ce91-4a24-8624-bb7626f8bd86",
		"slug": "fireworks",
		"caption": "Fireworks",
		"alt": "Color fest",
		"username": "laf",
		"width": 2048,
		"height": 1536,
		"imageUrl": "https://images03.foap.com/images/e70d08f00bc74a6e8623ca6bba1e80a7/original.jpg?filename=web_review&dw=640",
		"selectedCaption": "Fireworks"
	},
	{
		"id": "ebad50b0-e431-4529-8423-c9500202549f",
		"albumId": "ebad50b0-e431-4529-8423-c9500202549f",
		"slug": "typical-swedish",
		"caption": "Typical Swedish",
		"alt": "Bun",
		"username": "somliga2",
		"width": 3300,
		"height": 2200,
		"imageUrl": "https://images02.foap.com/images/c9ab91bc4b0a456d83d6899e3c86995a/original.jpg?filename=web_review&dw=640",
		"selectedCaption": "Typical Swedish"
	},
	{
		"id": "89ad4340-0b95-4a0d-821c-0384cf056f5a",
		"albumId": "89ad4340-0b95-4a0d-821c-0384cf056f5a",
		"slug": "bucket-list-destinations",
		"caption": "Bucket List Destinations",
		"alt": "Rocky coast",
		"username": "pieces.of.my.life",
		"width": 3024,
		"height": 4032,
		"imageUrl": "https://images01.foap.com/images/7ba652a7-d8f0-4c86-b914-82020daca7af/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Bucket List Destinations"
	},
	{
		"id": "66b3636d-d064-47ba-940c-37f5119596c1",
		"albumId": "66b3636d-d064-47ba-940c-37f5119596c1",
		"slug": "traditional-christmas",
		"caption": "Traditional Christmas ",
		"alt": "Winter ",
		"username": "upyanose",
		"width": 2048,
		"height": 1536,
		"imageUrl": "https://images01.foap.com/images/47b8750e-669e-4f8c-be55-75a134378af9/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Traditional Christmas "
	},
	{
		"id": "fdb29790-fa17-4f22-b389-c68d172195a8",
		"albumId": "fdb29790-fa17-4f22-b389-c68d172195a8",
		"slug": "light-trees",
		"caption": "Light & trees",
		"alt": "Fall in Innsbruck. Taken on my backpacking trip across Europe in Innsbruck, Austria. ",
		"username": "greendub",
		"width": 2448,
		"height": 3264,
		"imageUrl": "https://images01.foap.com/images/7ca1df68-089c-4941-ac0a-3b31ceddf0a1/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Light & trees"
	},
	{
		"id": "4f21ea29-dcd8-431e-b3f4-1d225eab18fb",
		"albumId": "4f21ea29-dcd8-431e-b3f4-1d225eab18fb",
		"slug": "bangkok",
		"caption": "Bangkok",
		"alt": "food boats bangkok thailand by paulcowell",
		"username": "lironialessandro",
		"width": 1536,
		"height": 2304,
		"imageUrl": "https://images01.foap.com/images/f0af402c475d4e3b8650f3e8c05301c9/original.jpg?filename=web_review&dw=640",
		"selectedCaption": "Bangkok"
	},
	{
		"id": "81ea9efc-808b-416a-af4c-b4ca98881d21",
		"albumId": "81ea9efc-808b-416a-af4c-b4ca98881d21",
		"slug": "birds",
		"caption": "Birds",
		"alt": "Cedar waxwing",
		"username": "jlmcanally",
		"width": 640,
		"height": 960,
		"imageUrl": "https://images02.foap.com/images/f22bffd5652e47359b0e531eec1db813/original.jpg?filename=web_review&dw=640",
		"selectedCaption": "Birds"
	},
	{
		"id": "6eb41f88-08b8-4be2-958e-c78c9e53fc3e",
		"albumId": "6eb41f88-08b8-4be2-958e-c78c9e53fc3e",
		"slug": "poland",
		"caption": "Poland",
		"alt": "Winter in Poland",
		"username": "adrianwerner",
		"width": 2982,
		"height": 2982,
		"imageUrl": "https://images02.foap.com/images/2bc17707-761d-483d-bf37-c84b6647caa5/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Poland"
	},
	{
		"id": "928fd7d3-69af-426c-b17f-10a96d676d6d",
		"albumId": "928fd7d3-69af-426c-b17f-10a96d676d6d",
		"slug": "flat-laying-in-the-kitchen",
		"caption": "Flat laying in the kitchen",
		"alt": "Himalayan salt",
		"username": "happytails",
		"width": 2304,
		"height": 1536,
		"imageUrl": "https://images02.foap.com/images/699819f0-8f18-4f84-b600-15ab2880e760/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Flat laying in the kitchen"
	},
	{
		"id": "631090e4-0bb6-41e9-9f3c-74a3a2b4be43",
		"albumId": "631090e4-0bb6-41e9-9f3c-74a3a2b4be43",
		"slug": "adventure",
		"caption": "Adventure",
		"alt": "Crazy morning fog. ",
		"username": "ican",
		"width": 5440,
		"height": 3627,
		"imageUrl": "https://images03.foap.com/images/9bbc2d82-d6aa-4f8d-ad4c-170b9c0ab0eb/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Adventure"
	},
	{
		"id": "0505aa9f-7fa1-48d1-9cfa-5d3a7fbfe9eb",
		"albumId": "0505aa9f-7fa1-48d1-9cfa-5d3a7fbfe9eb",
		"slug": "wildlife",
		"caption": "Wildlife",
		"alt": "Wildlife",
		"username": "ican",
		"width": 1984,
		"height": 1488,
		"imageUrl": "https://images01.foap.com/images/859bda8b-5311-4930-be7b-836ee0d26d84/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Wildlife"
	},
	{
		"id": "b9cda7a2-8bfc-44e2-b045-7d185892328a",
		"albumId": "b9cda7a2-8bfc-44e2-b045-7d185892328a",
		"slug": "lovely-garden-flowers",
		"caption": "Lovely garden flowers",
		"alt": "Pion flower\n",
		"username": "christina_fs",
		"width": 3888,
		"height": 2592,
		"imageUrl": "https://images02.foap.com/images/f26373a6-d144-4987-9261-8a2bf11eea69/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Lovely garden flowers"
	},
	{
		"id": "f15b8627-d0a4-4812-a0ce-28da02f7369a",
		"albumId": "f15b8627-d0a4-4812-a0ce-28da02f7369a",
		"slug": "pets",
		"caption": "Pets",
		"alt": "Oxen. My friends cute dog",
		"username": "ananasska",
		"width": 4912,
		"height": 3264,
		"imageUrl": "https://images02.foap.com/images/8c866f09-b029-4a48-88b1-43f4244cfff2/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Pets"
	},
	{
		"id": "b952f3e1-b6c6-4e84-8032-cb28f35315b9",
		"albumId": "b952f3e1-b6c6-4e84-8032-cb28f35315b9",
		"slug": "childhood",
		"caption": "childhood",
		"alt": "Boy... sea",
		"username": "ananasska",
		"width": 1535,
		"height": 2308,
		"imageUrl": "https://images03.foap.com/images/66c6c6b64a4043599ef747a1b1558b0a/original.jpg?filename=web_review&dw=640",
		"selectedCaption": "childhood"
	},
	{
		"id": "53ee5fdb-0aed-4f8b-9cc2-49f8469ea978",
		"albumId": "53ee5fdb-0aed-4f8b-9cc2-49f8469ea978",
		"slug": "monochrome",
		"caption": "Monochrome",
		"alt": "Carlton hill",
		"username": "dmzelman",
		"width": 2000,
		"height": 1325,
		"imageUrl": "https://images03.foap.com/images/c7dfd88a-bba9-422f-b085-fb5d247a63f5/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Monochrome"
	},
	{
		"id": "cf6a8d1f-7114-47a5-ba34-96d0cfc1232b",
		"albumId": "cf6a8d1f-7114-47a5-ba34-96d0cfc1232b",
		"slug": "roads-of-bliss",
		"caption": "Roads of bliss",
		"alt": "Point Reyes",
		"username": "hddatmyers",
		"width": 2268,
		"height": 4032,
		"imageUrl": "https://images03.foap.com/images/8b3a6c36-5a4b-44b1-a649-4c1fec9b6a29/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Roads of bliss"
	},
	{
		"id": "e0bb5d66-a3ef-4416-a06d-ac38d979717f",
		"albumId": "e0bb5d66-a3ef-4416-a06d-ac38d979717f",
		"slug": "fresh-fruits-vegetables",
		"caption": "Fresh Fruits & Vegetables ",
		"alt": "Harvested onions, apples and squash in a pile of produce.",
		"username": "shannonfieldsphoto",
		"width": 4096,
		"height": 2730,
		"imageUrl": "https://images01.foap.com/images/183a5e2f-9413-433f-8130-29bcf88fb2e5/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Fresh Fruits & Vegetables "
	},
	{
		"id": "63ff22d7-4723-4c2f-8651-bb0c708a2f8b",
		"albumId": "63ff22d7-4723-4c2f-8651-bb0c708a2f8b",
		"slug": "animals",
		"caption": "Animals",
		"alt": "geese",
		"username": "pieces.of.my.life",
		"width": 1600,
		"height": 1066,
		"imageUrl": "https://images02.foap.com/images/7f46e51d-969a-4e0d-a9c3-57e511dc3533/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Animals"
	},
	{
		"id": "99c9198f-82f1-44cd-9197-1be8a41357dc",
		"albumId": "99c9198f-82f1-44cd-9197-1be8a41357dc",
		"slug": "stylish-food",
		"caption": "Stylish food",
		"alt": "cornflakes",
		"username": "bussardel",
		"width": 2089,
		"height": 2089,
		"imageUrl": "https://images02.foap.com/images/72fd598a-7bcd-46a1-b718-12d1239bdb45/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Stylish food"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/containers/global/Market/data/albums.json
// module id = 3162
// module chunks = 39